import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

interface PaymentMethodAddedData {
  paymentType?: string; // 'ACH' or 'card' (matches FinancialAccountPaymentMethodType / FinancialAccountPaymentMethod enums)
  isAutoPay?: boolean;
  isAccountValidated?: boolean; // only meaningful for ACH; omitted for cards
}

const SabalPaymentMethodAdded = ({ event }: { event: any }) => {
  const data: PaymentMethodAddedData = event?.data ?? {};
  const { paymentType, isAutoPay, isAccountValidated } = data;

  // Map the stored payment-type value to a display label.
  // 'card' → 'Credit card' (friendlier); 'ACH' stays as 'ACH'.
  const paymentTypeLabel = paymentType === 'card' ? 'Credit card' : paymentType;

  const autoPayLabel = isAutoPay === true ? ' as auto-pay' : isAutoPay === false ? ' to wallet' : '';

  const validatedLabel =
    paymentType === 'ACH' && isAccountValidated !== undefined
      ? ` (${isAccountValidated ? 'validated' : 'not validated'})`
      : '';

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />{' '}
        {paymentTypeLabel ? (
          <>
            added <strong>{paymentTypeLabel}</strong> payment method
            {autoPayLabel}
            {validatedLabel}
          </>
        ) : (
          'payment method added'
        )}
      </Box>
    </Box>
  );
};

export default SabalPaymentMethodAdded;
